//
// ResponsiveLayoutScrollDirection.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var ResponsiveLayoutScrollDirection = {
    NONE:0,
    HORIZONTAL:1,
    VERTICAL:2,
    HORIZONTAL_AND_VERTICAL:3
};
export default ResponsiveLayoutScrollDirection;
